module.exports = __webpack_public_path__ + "static/media/features-section-image-1.920112b1.png";